<template>
  <div
    :class="['section', {'has-subsections':hasSubsections},{'recurring-section':recurringSection},{'ui-hidden':hideGlobalUI}]"
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    v-toggle-select
    v-on-clickaway="deselect"    
  >
    <section-title
      :key="menu.acf.last_save_timestamp"
      :title="section.section_title"
      :editable="isEditable"
      :priceColumns="section.section_price_columns"
      @addPriceColumn="addPriceColumn"
      @update="section.section_title = $event"
      ref="sectionTitle"
    />

    <draggable
      v-if="section.items.length && !hasSubsections"
      class="menu-items"
      v-model="section.items"
      :options="{group:'menu-items', handle:'.drag-handle',disabled:!isAuthenticated}"
      @start="onDragStart"
      @end="dragging = false"
      @choose="dragging = true"
      @unchoose="dragging = false"
    >
      <!-- <transition-group name="fade" tag="div"> -->
        <menu-item
          v-for="(item, item_index) in section.items"
          v-if="!parseInt( wpData.togo ) || ( parseInt( wpData.togo ) && !item.item_isSpecial)"
          :key="`${menu.acf.last_save_timestamp}_${section.section_uuid + item.item_uuid}`"
          :item="item"
          :dragging="dragging"
          :sectionColumns="section.section_price_columns"
          @updatePrices="updateItemPrices(item_index, ...arguments)"
          @removeItem="removeItem"
          @addItem="addItem"
        />

      <!-- </transition-group> -->
    </draggable>

    <draggable
      v-if="hasSubsections"
      class="menu-subsections"
      v-model="section.subsections"
      :options="{group:'menu-subsections',disabled:!isAuthenticated}"
      @start="onDragStart"
      @end="dragging = false"
      @choose="dragging = true"
      @unchoose="dragging = false"
    >
        <subsection
          v-for="(subsection,index) in section.subsections"
          :key="`${menu.acf.last_save_timestamp}_${section.section_uuid + subsection.subsection_uuid}`"
          :subsection="subsection"
          :dragging="dragging"
          @removeSubsection="removeSubsection"
          @addSubsection="addSubsection"
        />

    </draggable>

    <transition name="fade">
      <button-cluster
        v-if="showExtras || hovering"
        :buttons="buttons"
        :item="section"
        highlight="blue"
        bottomCenter
      />
    </transition>  
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import EditableTextField from '../EditableTextField'
import MenuSectionTitle from './MenuSectionTitle'
import MenuItem from './MenuItem'
import MenuSubsection from './MenuSubsection'
import ButtonCluster from '../UI/ButtonCluster'

import _random from 'lodash/random'
import _findIndex from 'lodash/findIndex'
import _cloneDeep from 'lodash/cloneDeep'
import _size from 'lodash/size'
import _find from 'lodash/Find'

import VueClickaway from 'vue-clickaway'
import ToggleSelect from '../../toggle-select'

import { mapGetters, mapState } from 'vuex'

export default {

  name: 'MenuSection',
  mixins : [ VueClickaway.mixin, ToggleSelect ],  
  props : {
    'menu' : [Object, Array],
    'section' : [Object, Array],
    'isDrinksMenuSection' : {
      type : Boolean,
      default : false
    },
    'recurringSection' : {
      type : Boolean,
      default : false
    }
  },  
  components : {
    draggable,
    'editable-text' : EditableTextField,
    'section-title' : MenuSectionTitle,
    'menu-item' : MenuItem,
    'button-cluster' : ButtonCluster,
    'subsection' : MenuSubsection
  },
  methods :  {
    addItem( item_uuid ) {
      // if( item_uuid ) {
      //   var item_index = _findIndex(this.section.items, item => item.item_uuid == item_uuid );
      // }
      let newItemNum = this.section.items.length + 1
      let itemTitles = ["Satsuma Breakfast Plate","Mediterranean Quinoa Salad","Black Bean Burger","Calcium Injection","Popeye", "Mexican Breakfast Plate"]
      let itemTitle = itemTitles[_random(0, itemTitles.length-1)]

      let descriptions = [
        "Bacon, tomato, arugula, goat cheese and avocado on sourdough or wheat",
        "scrambled egg with basil pesto, shaved Nueske’s ham, melted swiss and red onion on croissant",
        "2 eggs (any style), Nueske’s bacon, creamy black beans, fresh fruit, toast or biscuit",
        "Lacinato kale, spinach, hardboiled egg, cherry tomatoes, bacon, avocado, basil, parmesan croutons and a creamy garlic dressing.",
        "apple, carrot, beet, lemon"
      ];
      let description = descriptions[_random(0, descriptions.length-1)]

      let newItem = {
        // item_title : itemTitle,
        item_title : 'New Item',
        item_uuid : Date.now() + newItemNum,
        item_prices : [],
        // item_description : description,
        item_description : '',
        item_addons : [],
        item_isSpecial : false,
        new : true

      };
      // WP ACF REST returns false for empty array
      if( "undefined" === typeof this.section.items || !this.section.items ) {
        this.section.items = []
      }

      // Hack workaround
      // if( item_uuid ) {
      //   this.section.items.splice(item_index+1, 0, newItem);
      // } else {
        this.section.items.push(newItem);
      // }
    },

    removeItem(item_id) {
      this.section.items = this.section.items.filter(item=> item.item_uuid !== item_id )      
    }, // removeItem

    updateItemPrices(item_index, newPrices) {
      // this.section.items[item_index].item_prices = newPrices;
      let clone = _cloneDeep( this.section.items[item_index] );
      clone.item_prices = newPrices;
      this.section.items.splice( item_index, 1, clone)
    }, // updateItemPrices

    addSubsection() {
      let copiedSectionItems = false
      if( !this.hasSubsections ) {
        this.section.subsections = []
        copiedSectionItems = this.section.items;
        this.section.items = [];
      }

      let newSubsectionNum = this.section.subsections.length + 1

      let newSubsection = {
        subsection_title : 'Subsection Title',
        subsection_uuid : Date.now() + newSubsectionNum,
        items : copiedSectionItems || [],
        subsection_price_columns: []
      };

      this.section.subsections.push(newSubsection)
    }, // addSubsection

    removeSubsection(ss_id) {
      // if this is the last section, get the items
      // and add them to the parent section
      let clonedItems = false;
      if( this.section.subsections.length == 1 ) {
        var theSubsection = this.section.subsections.find(ss=> ss.subsection_uuid == ss_id )
        clonedItems = theSubsection.items;
      }
      this.section.subsections = this.section.subsections.filter(ss=> ss.subsection_uuid !== ss_id )      
      this.$nextTick().then( ()=> {
        if( clonedItems ) {
          this.section.items = clonedItems;
        }
      })
    }, // removeSubsection



    onDragStart() {
      this.dragging = true
      this.selected = true
      this.$emit('itemDragStart');
    },

    onDragEnd() {
      this.dragging = false
    },

    onDragChoose() {
      this.dragging = true
    },

    onDragUnchoose() {
      this.dragging = false
    },

    addPriceColumn(item, event) {
      event.stopPropagation();
      if( !this.section.section_price_columns ) {
        this.section.section_price_columns  = []
      }
      this.section.section_price_columns.push({'price':''})
      let self = this;
      this.$nextTick().then( ()=> {
        let priceIndex = this.section.section_price_columns.length-1;
        self.$refs.sectionTitle.focusNewPrice(priceIndex)
      })

    }, // addPriceColumn

    resetDeleteButton() {
      let deleteBtn = _find(this.buttons, btn => { return btn.title == this.confirmMsg; })
      deleteBtn.title = 'Section';
      deleteBtn.icon = this.deleteIcon;
      deleteBtn.class = '';
      this.confirmDelete = false;
    }, // resetDeleteButton

    deleteConfirmationCheck() {
      let deleteBtn = _find(this.buttons, btn => { return btn.icon == this.deleteIcon; })
      deleteBtn.title = this.confirmMsg;
      deleteBtn.icon = false;
      deleteBtn.class = 'delete-confirmation';
      this.confirmDelete = true;
    }, // deleteConfirmationCheck


    deleteConfirmation(section) {
      if( !this.confirmDelete ) {
        this.deleteConfirmationCheck();
        this.confirmationTimeout = setTimeout( this.resetDeleteButton, 2000)
        return false;
      } else {
        clearTimeout(this.confirmationTimeout)
        this.$emit('removeSection', section.section_uuid);
      }
      
    }, // deleteConfirmation
  },
  data () {
    return {
      hovering : false,
      dragging : false,
      confirmDelete : false,
      confirmMsg : 'You Sure?',
      deleteIcon : 'delete',
      buttons : [
        {
          title : 'Item',
          icon : 'add_circle',
          // iconOnly : true,
          // dragGroup : {
          //   name : 'item-addons',
          //   pull : 'false'
          // },
          clickHandler : this.addItem,
          // dragStartAction : this.addButtonDragStart,
          // dragEndAction : this.addButtonDragEnd,
          // dragChangeAction : this.addButtonDragChange,
          mouseupAction : ()=>{},
          mousedownAction : ()=>{},
          conditional : ()=>{return !this.hasSubsections},

        },
        {
          title : 'Subsection',
          icon : 'add_circle',
          clickHandler : this.addSubsection,
          mouseupAction : ()=>{},
          mousedownAction : ()=>{},
          conditional : ()=>{return this.isDrinksMenuSection }
        },
        {
          title : 'Section',
          icon : 'delete',
          // iconOnly : true,
          class : 'btn-delete-gray',
          clickHandler : this.deleteConfirmation,
          mouseupAction : ()=>{},
          mousedownAction : ()=>{},
        },

      ]      
    }
  },
  computed: {
    showExtras() {
      return !this.disabled && (this.showUI || this.hovering || this.selected);
    },
    hasSubsections() {
      return _size(this.section.subsections) > 0;
    }, // hasSubsections
    ...mapGetters(['isAuthenticated']),
    ...mapState(['wpData'])
  },
  created() {
  }, // created
}
</script>

<style lang="scss">
$borderWidth : 2px;
$padding : 12px;
@mixin hoverElem {
  &:before {
    transition:box-shadow .3s ease;
    content : '';
    position:absolute;
    z-index:-1;
    height:calc(100% + #{$borderWidth*2});
    width:calc(100% + #{($borderWidth*2 + $padding*3)});
    right:-#{$padding*2};
    top:0px;
    border:$borderWidth solid darken(white, 7%);
    border-bottom-color:#27b9f1;
  }
  &:not(.selected):before{ 
    background-color:darken(white, 3%);
  }

}


.section {
  position:relative; 
  border:2px solid transparent;
  &:hover, &.selected {
    &:not(.ui-hidden) {
      cursor:pointer;
    }
    > .button-cluster {
      display:flex;
      bottom:-40px;
    }
  }
  &.selected {
    @include hoverElem;
    &:before {
      border-width:0 0 2px;
      border-bottom-color:transparent;
      // border-bottom-color:#27b9f1;
      // border-bottom-style:solid;
      width:calc(100% + #{($borderWidth*2 + $padding*4)});
      box-shadow:0px 12px 35px -17px #27b9f1;      
      right:-#{$padding*2};
    }
  }
  &:not(.selected,.ui-hidden) {
    &:hover {
      @include hoverElem;
    }
  }
  &.has-subsections {
    @media (min-width:1400px) {
      padding-bottom:40px;
    }
  }
  &.ui-hidden {
    &:before {
      display:none !important;
    }
  }
}

.menu:not(.drinks-menu) .recurring-section {
  .section-title-wrap {
    display:none;
  }
}


</style>


// WEBPACK FOOTER //
// src/components/Menus/MenuSection.vue